module.exports = __webpack_public_path__ + "static/img/02.cb7a08e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/loacker/02.jpg
// module id = 417
// module chunks = 1